// extracted by mini-css-extract-plugin
export default {"wrapper":"jKHew0","message":"_jzgpS"};